import {getComponent, getCompRef} from './common';
import {StoresWidgetID} from '@wix/wixstores-client-core';
import {EditorSDK, StyleParam} from '@wix/platform-editor-sdk';

export async function setupCategoryPageNewLayout(sdk: EditorSDK) {
  const categoryPageWidgetComp = await getComponent(sdk, StoresWidgetID.CATEGORY_PAGE);
  const categoryPageWidgetRef = await getCompRef(sdk, categoryPageWidgetComp);

  await sdk.tpa.setStyleParams('', {
    compRef: categoryPageWidgetRef,
    styleParams: [
      {type: 'number', key: 'gallery_categoryHeaderPosition', param: {value: 1}},
      {type: 'boolean', key: 'gallery_showDigitalBadge', param: {value: false}},
    ],
  });
}

const modernLayoutStyleParams = {
  numbers: {
    productPage_layoutId: 8,
    productPage_descriptionVisibleLineNumbers: 3,
    productPage_infoSectionColumnNumber: 3,
    productPage_infoSectionTypeId: 1,
    productPage_galleryImageMode: 1,
    productPage_galleryImageRatio: -1,
    productPage_textualOptionType: 2,
    productPage_mainColumnRatio: 60,
    productPage_socialShareIconsTheme: 1,
  },
  strings: {
    productPage_descriptionAlignment: 'left',
    productPage_productDetailsAlignment: 'left',
    productPage_infoSectionAlignment: 'left',
    productPage_galleryNavigationType: 'thumbnails',
    productPage_galleryNavigationLocation: 'outside',
    productPage_galleryNavigationPosition: 'left',
  },
  booleans: {
    productPage_infoSectionShowDeviders: true,
    productPage_buyNowButtonEnabled: true,
    productPage_navigation: false,
    productPage_productSku: false,
  },
};

export async function setupProductPageNewLayout(sdk: EditorSDK) {
  const productPageWidgetComp = await getComponent(sdk, StoresWidgetID.PRODUCT_PAGE);
  const productPageWidgetRef = await getCompRef(sdk, productPageWidgetComp);
  const styleParams: StyleParam[] = [];

  Object.keys(modernLayoutStyleParams.numbers).forEach((key) => {
    styleParams.push({type: 'number', key, param: {value: modernLayoutStyleParams.numbers[key]}});
  });

  Object.keys(modernLayoutStyleParams.strings).forEach((key) => {
    styleParams.push({
      type: 'font',
      key,
      param: {value: {fontStyleParam: false, value: modernLayoutStyleParams.strings[key]}},
    });
  });

  Object.keys(modernLayoutStyleParams.booleans).forEach((key) => {
    styleParams.push({type: 'boolean', key, param: {value: modernLayoutStyleParams.booleans[key]}});
  });

  if (styleParams.length > 0) {
    await sdk.tpa.setStyleParams('', {
      compRef: productPageWidgetRef,
      styleParams,
    });
  }
}
